<div class="logout-page-container">
  <div class="logout-message-box">
    <img src="/images/logo.png" alt="Logo" class="logout-logo" />
    <h2>You are successfully logged out</h2>
    <p>Please click below to refresh or close the browser.</p>
    <button class="btn btn-primary" (click)="refreshPage()">Refresh</button>
  </div>
</div>
